import React from 'react'

import { Button } from '@/components/buttons/Button'

export const EventFilters = (props) => {
  const title = `${props.title}:`

  return (
    <div className="events-viewer-actions" data-testid="event-filters">
      <div className="events-viewer-actions-top">
        <h2 data-testid="events-viewer-title">{title}</h2>

        <div className="events-viewer-filters">
          {props.filterOptions.map((option) => {
            const key = `${option.id}-selector`

            return (
              <Button
                key={key}
                data-testid={key}
                text
                link={props.selectedFilters === option.id}
                onClick={() => props.handleFilterSelect(option)}
              >
                {option.label}
              </Button>
            )
          })}
        </div>
      </div>
    </div>
  )
}
